import { isReducerRegistered, registerReducer, getStore } from "@crystal/redux";
import * as rtk from "@reduxjs/toolkit";
import { useState, useRef, useEffect } from "react";
const { createSlice } = { ...rtk }.default || rtk;
const SLICE_NAME = "accountConsents";
const SCENARIOS_TYPES = [
  "signup",
  "signup-email-paidmedia",
  "registration",
  "app-registration",
  "pos-registration",
  "Runtastic-registration",
  "account-optout",
  "account-optin",
  "guest-checkout",
  "tr-government-optout",
  "login"
];
const dispatch = (action) => getStore().dispatch(action);
const initState = () => SCENARIOS_TYPES.reduce((acc, current) => {
  if (!acc[current]) {
    acc[current] = {
      payload: {
        legalAcceptance: {
          scenarioName: "",
          acceptanceLocale: "",
          acceptances: []
        }
      }
    };
  }
  return acc;
}, {});
const consentsSlice = createSlice({
  name: SLICE_NAME,
  initialState: initState(),
  reducers: {
    setConsentsState: (state, { payload }) => {
      const type = Object.keys(payload)[0];
      const current = state[type];
      const update = payload[type];
      const { acceptances: currentAcceptances } = current.payload.legalAcceptance;
      const { acceptances: updated } = update.payload.legalAcceptance;
      if (current.payload.legalAcceptance.scenarioName === update.payload.legalAcceptance.scenarioName && current.payload.legalAcceptance.acceptanceLocale === update.payload.legalAcceptance.acceptanceLocale) {
        const unchanged = currentAcceptances.filter((a) => !updated.find((u) => u.documentName === a.documentName));
        current.payload.legalAcceptance.acceptances = [...unchanged, ...updated];
        current.payload.legalAcceptance.scenarioName = update.payload.legalAcceptance.scenarioName;
        current.payload.legalAcceptance.acceptanceLocale = update.payload.legalAcceptance.acceptanceLocale;
        current.isValid = update.isValid;
      } else {
        state[type] = update;
      }
    },
    setShowErrors: (state, { payload }) => {
      state[payload].showErrors = true;
    },
    setHideErrors: (state, { payload }) => {
      state[payload].showErrors = false;
    }
  }
});
const { actions } = consentsSlice;
const getState = () => getStore().getState();
function initConsentsPayloadState() {
  if (!isReducerRegistered(SLICE_NAME)) {
    registerReducer(SLICE_NAME, consentsSlice.reducer);
    return true;
  }
}
function useConsentsState() {
  const [state, setState] = useState();
  const hasUnmounted = useRef(false);
  useEffect(() => {
    initConsentsPayloadState();
    const unsubscribe = getStore().subscribe(() => {
      if (hasUnmounted.current) {
        return;
      }
      const consentState = getState()[SLICE_NAME];
      if (state !== consentState) {
        setState(consentState);
      }
    });
    return () => {
      hasUnmounted.current = true;
      unsubscribe();
    };
  }, []);
  return {
    ...state
  };
}
function onConsentsChange(listener) {
  const store = getStore();
  let oldValue = getState()[SLICE_NAME];
  const unsubscribe = store.subscribe(() => {
    const consents = getState()[SLICE_NAME];
    if (consents !== oldValue) {
      oldValue = consents;
      listener(consents);
    }
  });
  return unsubscribe;
}
const setConsentsState = (payload) => {
  dispatch(actions.setConsentsState(payload));
};
const showErrors = (type) => {
  var _a;
  if (!((_a = getState()[SLICE_NAME][type]) == null ? void 0 : _a.showErrors)) {
    dispatch(actions.setShowErrors(type));
  }
};
const hideErrors = (type) => {
  var _a;
  if ((_a = getState()[SLICE_NAME][type]) == null ? void 0 : _a.showErrors) {
    dispatch(actions.setHideErrors(type));
  }
};
export {
  hideErrors,
  initConsentsPayloadState,
  onConsentsChange,
  setConsentsState,
  showErrors,
  useConsentsState
};
//# sourceMappingURL=index.js.map
